module.exports = __webpack_public_path__ + "img/12.8.TSS.6ca7d8d0.png";